import Vue from 'vue'
import VueRouter from 'vue-router'
import MainView from '../views/MainView.vue'
import PrivacyPolicyView from '../views/PrivacyPolicyView.vue'
import HousingOptionsDetailView from '../views/HousingOptionsDetailView.vue'
import UserAgreementView from '../views/UserAgreementView.vue'
import RefundsCancellationsView from "../views/RefundsCancellationsView";
import CookiesPolicyView from "@/views/CookiesPolicyView";

Vue.use(VueRouter)

const routes = [
	{
		path: '/',
		name: 'main',
		component: MainView
	},
	{
		path: '/housing_option/:id',
		name: 'housing_option',
		component: HousingOptionsDetailView,
	},
	{
		path: '/privacy_policy',
		name: 'privacy_policy',
		component: PrivacyPolicyView,
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		// component: () => import(/* webpackChunkName: "about" */ '../views/PrivacyPolicyView.vue')
	},
	{
		path: '/user_agreement',
		name: 'user_agreement',
		component: UserAgreementView,
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		// component: () => import(/* webpackChunkName: "about" */ '../views/PrivacyPolicyView.vue')
	},
	{
		path: '/refunds_cancellations',
		name: 'refunds_cancellations',
		component: RefundsCancellationsView,
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		// component: () => import(/* webpackChunkName: "about" */ '../views/PrivacyPolicyView.vue')
	},
	{
		path: '/cookies_policy',
		name: 'cookies_policy',
		component: CookiesPolicyView,
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		// component: () => import(/* webpackChunkName: "about" */ '../views/PrivacyPolicyView.vue')
	},

]

const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	routes,
// 	scrollBehavior(to, from, savedPosition) {
// 		console.log(to, from, savedPosition)
// 		// Scroll to the top of the page for all route navigations
// 		if (from.name === 'main') {
// 			window.scrollTo(0, 0);
// 			// Optionally, use vue-scrollto for other scroll behaviors
// 			return {x: 0, y: 0}; // Adjust according to your needs
// 		}
// 	},
})

let needReload = false
// eslint-disable-next-line
router.afterEach((to, from, next) => {
	if (from.name === 'main' && to.name ==='housing_option') {
		needReload = true
	}
	if (needReload) {
		needReload = false
		location.reload()
	}
})

export default router


